import { Component, ElementRef, Input, OnInit, OnDestroy } from '@angular/core';

import { Observable, Subject } from 'rxjs';
import { ModalService } from '../_services/index';



@Component({
    selector: 'image-modal',
    standalone: false,
    template: '<ng-content></ng-content>'
})

export class ModalComponent implements OnInit, OnDestroy {
    @Input() id: string;
    private element: HTMLElement;

    constructor(private modalService: ModalService, private el: ElementRef) {
        this.element = el.nativeElement;
    }

    ngOnInit(): void {
        let modal = this;

        // ensure id attribute exists
        if (!this.id) {
            console.error('modal must have an id');
            return;
        }

        // move element to bottom of page (just before </body>) so it can be displayed above everything else
        document.body.appendChild(this.element);

        // close modal on background click
        this.element.addEventListener('click', (e: MouseEvent) => {
            const target = e.target as HTMLElement;
            if (!target.closest('.modal-body')) {
                modal.close();
                this.modalService.modalAction(false);
            }
        });

        // add self (this modal instance) to the modal service so it's accessible from controllers
        this.modalService.add(this);
    }

    // remove self from modal service when directive is destroyed
    ngOnDestroy(): void {
        if (this.modalService.modalExists(this.id)){
            this.modalService.remove(this.id);
        }
        this.element.style.display = 'none';
        this.element.style.pointerEvents = 'none';
        document.body.classList.remove('image-modal-open');
        this.element.remove();
    }

    // open modal
    open(): void {
        this.element.style.display = 'block';
        this.element.style.pointerEvents = 'auto';
        document.body.classList.add('image-modal-open');
    }

    // close modal — fully deactivate hit-testing (VR-010; do not leave a live overlay)
    close(): void {
        this.element.style.display = 'none';
        this.element.style.pointerEvents = 'none';
        document.body.classList.remove('image-modal-open');
    }

    
}
